import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import Modal from '@amzn/meridian/modal';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import { InfoIconButton } from 'src/common/buttons/infoIconButton';
import { usePageContext } from 'src/hooks';
export const DealBadgePopover = ({ endTime, locale }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { bundle } = usePageContext();
    const formattedEndDate = new Date(endTime).toLocaleDateString(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
    return (_jsxs(_Fragment, { children: [_jsx(InfoIconButton, { onClick: () => setIsOpen(true), ariaLabel: bundle.getMessage('dealTermsInfoButton'), dataTestId: "deal-badge-terms-button" }), _jsx(Modal, { open: isOpen, onClose: () => setIsOpen(false), "data-testid": "deal-badge-terms-modal", children: _jsxs(Column, { spacing: "300", children: [_jsx(Text, { type: "h300", "data-testid": "deal-badge-terms-header", children: bundle.formatMessage('dealTermsHeader', { date: formattedEndDate }) }), _jsx(Text, { type: "b300", "data-testid": "deal-badge-terms-body", children: bundle.getMessage('dealTermsBody') })] }) })] }));
};
